import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState, useCallback } from "react";
import { GET } from "../service/CRUDService";
import EntityConstants from "../configs/EntityConstants";
import Toast from "../common/Toast/Toast";

const AuthContext = React.createContext({
  signOrSignUp: true,
  chooseSignUp_SignIn: () => {},

  triggerLoginModuleToggleValue: false,
  setTriggerLoginModuleToggleValue: () => {},

  isLoggedIn: false,
  login: () => {},

  logout: () => {},

  createUserProfile: () => {},
  user_profile_id: null,

  createUserProfileDetails: () => {},
  userDetails: null,

  createTenantId: () => {},
  tenant_id: null,

  createTenantName: () => {},
  tenant_name: null,
  isSignUpHandler: () => {},
  isSignUp: null,

  isGoogleLogin: false,
  googlelogin: () => {},

  googlelogout: () => {},

  isMicrosoftLogin: false,
  microsoftlogin: () => {},
  microsoftlogout: () => {},

  hasDiscoveryReachedBottomHandler: () => {},
  hasDiscoveryReachedBottom: false,

  lastVisitedPathHandler: () => {},
  lastVisitedPath: null,

  IssuedOffsetHandler: () => {},
  issuedOffset: null,

  ProgrammeOffsetHandler: () => {},
  programmeOffset: null,

  BatchOffsetHandler: () => {},
  batchOffset: null,

  DraftOffsetHandler: () => {},
  draftOffset: null,

  TenantOffsetHandler: () => {},
  tenantOffset: null,

  forgotPasswordHandler: () => {},
  isForgotPassword: false,

  rowCount: 0,
  setRowCount: () => {},

  isFileUploaded: false,
  setFileUploaded: () => {},

  creditCount: 0,
  setCreditCount: () => {},

  sidebarComponents: [],
  setSidebarComponents: () => {},

  userType: null,
  setUserType: () => {},

  tenantCode: null,
  setTenantCode: () => {},

  orgCode: null,
  setOrgCode: () => {},

  isLoading: true,
});

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user_profile_id, setUser_profile_id] = useState(null);
  const [tenant_id, setTenant_id] = useState(null);
  const [tenant_name, setTenant_Name] = useState(null);
  const [isSignUp, setIsSignUp] = useState(false);
  const [, setIsGoogleLogin] = useState(false);
  const [, setIsMicrosoftLogin] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [hasDiscoveryReachedBottom, setHasDiscoveryReachedBottom] =
    useState(false);
  const [lastVisitedPath, setLastVisitedPath] = useState(null);
  const [issuedOffset, setIssuedOffset] = useState(
    Number(localStorage.getItem("transactionOffset")) || null
  );
  const [programmeOffset, setProgrammeOffset] = useState(
    Number(localStorage.getItem("programmeOffset")) || null
  );
  const [batchOffset, setBatchOffset] = useState(
    Number(localStorage.getItem("batchOffset")) || null
  );
  const [draftOffset, setDraftOffset] = useState(
    Number(localStorage.getItem("draftOffset")) || null
  );

  const [tenantOffset, setTenantOffset] = useState(
    Number(localStorage.getItem("tenantOffset")) || null
  );
  const [triggerLoginModuleToggleValue, setTriggerLoginModuleToggleValue] =
    useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [creditCount, setCreditCount] = useState(0);
  const [sidebarComponents, setSidebarComponents] = useState([]);
  const [userType, setUserType] = useState(null);
  const [signOrSignUp, setSignOrSignUp] = useState(true);
  const [tenantCode, setTenantCode] = useState(null);
  const [orgCode, setOrgCode] = useState(null);

  useEffect(() => {
    const logoutReason = localStorage.getItem("logout_reason");
    if (logoutReason === "session_timeout") {
      Toast({
        type: "warning",
        title: "Session Timeout",
        message:
          "You have been logged out due to session timeout. Please sign in again.",
      });
      localStorage.removeItem("logout_reason");
    }
  }, []);

  // useEffects:
  useEffect(() => {
    lastVisitedPath && sessionStorage.setItem("previousPath", lastVisitedPath);
  }, [lastVisitedPath]);

  useEffect(() => {
    console.log("isForgotPasswordOpen>>>>", isForgotPasswordOpen);
  }, [isForgotPasswordOpen]);

  useEffect(() => {
    console.log(
      "triggerLoginModuleToggleValue>>",
      triggerLoginModuleToggleValue
    );
  }, [triggerLoginModuleToggleValue]);

  const resetUserDetails = useCallback(() => {
    setIsLoggedIn(false);
    setUser_profile_id(null);
    setTenant_id(null);
    setTenant_Name(null);
    setIsGoogleLogin(false);
    setIsMicrosoftLogin(false);
    setUserDetails({});
    setSidebarComponents([]);
    setUserType(null);
    setProgrammeOffset(0);
    setBatchOffset(0);
    setDraftOffset(0);
    setTenantOffset(0);
    setTenantCode(null);
    setOrgCode(null);
  }, []);

  const forceLogout = (reason = "manual") => {
    resetUserDetails();

    if (reason === "session_expired") {
      localStorage.setItem("logout_reason", "session_timeout");
    }

    localStorage.clear();
    sessionStorage.clear();

    if (reason === "session_expired") {
      localStorage.setItem("logout_reason", "session_timeout");
    }

    localStorage.setItem(
      "auth_event",
      JSON.stringify({ type: "LOGOUT", reason: reason, t: Date.now() })
    );
    window.location.replace("/");
  };

  const isRefreshTokenExpired = () => {
    try {
      const token = localStorage.getItem("refresh_token");
      if (!token) return true;
      const { exp } = jwtDecode(token);
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  };

  const validateSession = useCallback(async () => {
    const access = localStorage.getItem("auth_token");
    const refresh = localStorage.getItem("refresh_token");

    if (!access && !refresh) {
      setIsLoading(false);
      return false;
    }

    if (isRefreshTokenExpired()) {
      forceLogout("session_expired");
      return false;
    }

    try {
      const token = localStorage.getItem("auth_token");
      if (!token) throw new Error("No access token");
      const response = await GET(`${EntityConstants.CURRENT_USER}`);

      if (response.ok) {
        const data = await response.json();
        setIsLoggedIn(true);
        if (data.tenant_code) {
          setTenantCode(data.tenant_code);
        }
        if (data.org_code) {
          setOrgCode(data.org_code);
        }
        return true;
      } else {
        throw new Error("Access token invalid");
      }
    } catch {
      forceLogout("session_expired");
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    validateSession();
  }, [validateSession]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "auth_event") {
        try {
          const evt = JSON.parse(e.newValue || "{}");
          if (evt.type === "LOGOUT") {
            const logoutReason = evt.reason || "manual";
            forceLogout(logoutReason);
          }
        } catch {
          // ignore JSON parse errors
        }
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const createUserProfile = (id) => {
    setUser_profile_id(id);
  };

  const createUserProfileDetails = (userDetails) => {
    if (typeof userDetails === "object") {
      setUserDetails(userDetails);
      setUserType(userDetails.type?.toLowerCase() || null);
      setSidebarComponents(userDetails.sidebar_components || []);
      if (userDetails.tenant_code) {
        setTenantCode(userDetails.tenant_code);
      }
      if (userDetails.org_code) {
        setOrgCode(userDetails.org_code);
      }
    } else {
      setUserDetails({});
      setUserType(null);
      setSidebarComponents([]);
      throw new Error(
        '"object" / "{}" expected to create user profile details'
      );
    }
  };

  const createTenantId = (tenant_id) => {
    setTenant_id(tenant_id);
  };

  const createTenantName = (tenant_name) => {
    setTenant_Name(tenant_name);
  };

  const isSignUpHandler = (bool) => {
    setIsSignUp(bool);
  };

  const loginHandler = (userData) => {
    setIsLoggedIn(true);
    if (userData) {
      setUserType(userData.type?.toLowerCase() || null);
      setUserDetails(userData);
      setSidebarComponents(userData.sidebar_components || []);
      if (userData.tenant_code) {
        setTenantCode(userData.tenant_code);
      }
      if (userData.org_code) {
        setOrgCode(userData.org_code);
      }
      localStorage.setItem("userType", userData.type?.toLowerCase());
    }
  };

  const logoutHandler = () => {
    forceLogout("manual");
  };

  const googleloginHandler = () => {
    setIsGoogleLogin(true);
  };

  const googlelogoutHandler = () => {
    setIsGoogleLogin(false);
  };

  const microsoftLoginHandler = () => {
    setIsMicrosoftLogin(true);
  };

  const microsoftLogoutHandler = () => {
    setIsMicrosoftLogin(false);
  };

  const hasDiscoveryReachedBottomHandler = (bool) => {
    setHasDiscoveryReachedBottom(bool);
  };

  const lastVisitedPathHandler = (lastVisitedPath_) => {
    setLastVisitedPath(lastVisitedPath_);
  };

  const IssuedOffsetHandler = (offset) => {
    setIssuedOffset(offset);
    localStorage.setItem("transactionOffset", offset);
  };

  const ProgrammeOffsetHandler = (offset) => {
    setProgrammeOffset(offset);
    localStorage.setItem("programmeOffset", offset);
  };

  const BatchOffsetHandler = (offset) => {
    setBatchOffset(offset);
    localStorage.setItem("batchOffset", offset);
  };

  const TenantOffsetHandler = (offset) => {
    setTenantOffset(offset);
    localStorage.setItem("tenantOffset", offset);
  };

  const chooseSignUp_SignInHandler = (isSignIn) => {
    setSignOrSignUp(isSignIn);
  };

  const DraftOffsetHandler = (offset) => {
    setDraftOffset(offset);
    localStorage.setItem("draftOffset", offset);
  };

  const contextValue = {
    signOrSignUp: signOrSignUp,
    chooseSignUp_SignIn: chooseSignUp_SignInHandler,

    triggerLoginModuleToggleValue: triggerLoginModuleToggleValue,
    setTriggerLoginModuleToggleValue: setTriggerLoginModuleToggleValue,

    isLoggedIn,
    isLoading,
    login: loginHandler,

    logout: logoutHandler,

    createUserProfile: createUserProfile,
    user_profile_id: user_profile_id,

    createUserProfileDetails: createUserProfileDetails,
    userDetails: userDetails,

    createTenantId: createTenantId,
    tenant_id: tenant_id,

    createTenantName: createTenantName,
    tenant_name: tenant_name,

    isSignUpHandler: isSignUpHandler,
    isSignUp: isSignUp,

    googlelogin: googleloginHandler,

    googlelogout: googlelogoutHandler,

    hasDiscoveryReachedBottomHandler: hasDiscoveryReachedBottomHandler,
    hasDiscoveryReachedBottom: hasDiscoveryReachedBottom,

    lastVisitedPathHandler: lastVisitedPathHandler,
    lastVisitedPath: lastVisitedPath,

    IssuedOffsetHandler: IssuedOffsetHandler,
    issuedOffset: issuedOffset,

    ProgrammeOffsetHandler: ProgrammeOffsetHandler,
    programmeOffset: programmeOffset,

    BatchOffsetHandler: BatchOffsetHandler,
    batchOffset: batchOffset,

    DraftOffsetHandler: DraftOffsetHandler,
    draftOffset: draftOffset,

    TenantOffsetHandler: TenantOffsetHandler,
    tenantOffset: tenantOffset,

    microsoftLogin: microsoftLoginHandler,
    microsoftLogout: microsoftLogoutHandler,

    isForgotPassword: isForgotPasswordOpen,
    forgotPasswordHandler: () => setIsForgotPasswordOpen(!isForgotPasswordOpen),

    rowCount,
    setRowCount,

    isFileUploaded: fileUploaded,
    setFileUploaded,

    creditCount,
    setCreditCount,

    userType,
    setUserType,

    sidebarComponents,
    setSidebarComponents,

    tenantCode,
    setTenantCode,

    orgCode,
    setOrgCode,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
